import {
  IconDefinition,
  pencil,
  refresh,
  trash,
  ban,
  search,
} from '@amzn/storm-ui-icons';
import { CustomIconButtonColor } from '../../../../UiComponentsLibrary/CustomIconButton/constants/CustomIconButtonColor';
import { QueueSheetManagementRows } from '../interface/QueueSheetInterface';
import { BOOKING_ACTION_IDS } from '../../../constants/actionIds';

export interface ActionIconConfig {
  id: string;
  icon: IconDefinition;
  label: string;
  backgroundColor: string;
  handleOnClickCb: (item: QueueSheetManagementRows) => void;
}
{
  /* TODO: Implement onclick functionality for all this Icon buttons */
}
export const createActionButtonConfig = (
  handleEditClick: (item: QueueSheetManagementRows) => void,
  handleDeleteClick: (item: QueueSheetManagementRows) => void,
  handleRestoreClick: (item: QueueSheetManagementRows) => void,
  handleCancelClick: (item: QueueSheetManagementRows) => void,
  handleViewClick: (item: QueueSheetManagementRows) => void,
  isCancelledView?: boolean
): ActionIconConfig[] => {
  // For cancelled bookings, show only restore button
  if (isCancelledView) {
    return [
      {
        id: BOOKING_ACTION_IDS.RESTORE,
        icon: refresh,
        label: 'restore-button-label',
        backgroundColor: CustomIconButtonColor.restore,
        handleOnClickCb: handleRestoreClick,
      },
    ];
  }

  // For active bookings, show edit and delete buttons
  return [
    {
      id: BOOKING_ACTION_IDS.VIEW,
      icon: search,
      label: 'view-button-label',
      backgroundColor: CustomIconButtonColor.search,
      handleOnClickCb: handleViewClick,
    },
    {
      id: BOOKING_ACTION_IDS.EDIT,
      icon: pencil,
      label: 'edit-button-label',
      backgroundColor: CustomIconButtonColor.pencil,
      handleOnClickCb: handleEditClick,
    },
    {
      id: BOOKING_ACTION_IDS.DELETE,
      icon: trash,
      label: 'delete-button-label',
      backgroundColor: CustomIconButtonColor.delete,
      handleOnClickCb: handleDeleteClick,
    },
    {
      id: BOOKING_ACTION_IDS.CANCEL,
      icon: ban,
      label: 'cancel-button-label',
      backgroundColor: CustomIconButtonColor.cancel,
      handleOnClickCb: handleCancelClick,
    },
  ];
};
